// SPDX-FileCopyrightText: 2023 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import React, { useCallback, useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import useSettingsApi from './useSettingsApi';
import { DataUsageAgreement } from '@tls/sw91-communication/types/com.base';
import { ToastByStatus } from 'components/treactui-template/organisms/toast/ToastMessage';
import { Dialog, FooterButton } from '@tls/treact-ui';

export function InitialDataAgreementDialog() {
  const { t } = useTranslation();

  const { dataUsageAgreement, setDataAgreement } = useSettingsApi();

  const [open, setOpen] = useState<boolean>();

  useEffect(() => {
    if (dataUsageAgreement === DataUsageAgreement.UNSPECIFIED_DATA_USAGE_AGREEMENT) {
      setOpen(true);
      setDataAgreement(DataUsageAgreement.R_AND_D).then(result => {
        ToastByStatus(result.status, t('settings.data.initialized'), t('settings.data.initializedError'));
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataUsageAgreement]);

  const onClose = useCallback(() => {
    setOpen(false);
  }, []);
  return (
    <Dialog
      open={dataUsageAgreement === DataUsageAgreement.UNSPECIFIED_DATA_USAGE_AGREEMENT || open}
      size={'small'}
      enableClosing
      onClose={onClose}
      data-testid='settings-initial-data-agreement-dialog'
    >
      <Dialog.DialogHeader label={t('settings.data.title')} />
      <Dialog.DialogContent>
        <Trans i18nKey={t('settings.data.initialize')} />
      </Dialog.DialogContent>
      <Dialog.Footer
        right={
          <FooterButton
            variant='secondary'
            key='cancel'
            label={t('close')}
            onClick={onClose}
            data-testid='settings-initial-data-agreement-close-button'
          />
        }
      />
    </Dialog>
  );
}
